import React, { FC } from 'react';

import CheckboxField from '@buyside/components/presentation/Fields/checkboxField';

import { DISCLAIMERS } from '@buyside/util/researchSubmission';

const RequiredDisclaimerFields: FC = () =>
  (Object.keys(DISCLAIMERS.REQUIRED) as Array<
    keyof typeof DISCLAIMERS.REQUIRED
  >).map(disclaimerName => (
    <CheckboxField
      key={disclaimerName}
      label={DISCLAIMERS.REQUIRED[disclaimerName]}
      name={disclaimerName}
      size="small"
    />
  ));

export default RequiredDisclaimerFields;
